import { useState } from 'react';
import { tickerUpdates } from '@/mocks/home';

const navItems = [
  { label: '今日大瓜', href: '#hot' },
  { label: '明星黑料', href: '#category' },
  { label: '网红黑料', href: '#category' },
  { label: '实锤合集', href: '#truth' },
  { label: '往期盘点', href: '#timeline' },
];

export default function TopBar() {
  const [open, setOpen] = useState(false);
  const loop = [...tickerUpdates, ...tickerUpdates];

  return (
    <header id="top" className="sticky top-0 z-50">
      <div className="bg-foreground-950 text-background-50">
        <div className="mx-auto flex h-9 max-w-[1280px] items-center gap-3 px-4 md:px-6">
          <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap text-xs font-medium">
            <span className="relative flex h-1.5 w-1.5 items-center justify-center">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75"></span>
              <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-primary-500"></span>
            </span>
            实时更新中
          </span>
          <span className="hidden shrink-0 whitespace-nowrap text-xs text-background-400 sm:block">
            今日已汇总 <strong className="font-bold text-accent-400">47</strong> 条爆料
          </span>
          <div className="marquee-mask relative flex-1 overflow-hidden">
            <div className="flex w-max animate-marquee items-center gap-8 whitespace-nowrap">
              {loop.map((text, index) => (
                <span key={index} className="text-xs text-background-200">
                  <i className="ri-flashlight-fill mr-1.5 text-accent-400"></i>
                  {text}
                </span>
              ))}
            </div>
          </div>
          <a
            href="#submit"
            className="hidden shrink-0 whitespace-nowrap rounded-md bg-primary-500 px-3 py-1 text-xs font-medium text-background-50 hover:bg-primary-600 md:inline-flex"
          >
            投稿爆料
          </a>
        </div>
      </div>

      <div className="border-b border-background-200 bg-background-50/90 backdrop-blur">
        <div className="mx-auto flex h-14 max-w-[1280px] items-center justify-between gap-4 px-4 md:px-6">
          <a href="#top" className="flex shrink-0 items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-lg"></i>
            </span>
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">黑料吃瓜</span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#submit"
              className="hidden whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-sm text-foreground-700 hover:bg-background-100 sm:inline-flex"
            >
              下载客户端
            </a>
            <a
              href="#submit"
              className="hidden whitespace-nowrap rounded-md bg-foreground-950 px-3 py-1.5 text-sm font-medium text-background-50 hover:bg-foreground-800 sm:inline-flex"
            >
              匿名投稿
            </a>
            <button
              type="button"
              onClick={() => setOpen(!open)}
              aria-label="打开菜单"
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-800 hover:bg-background-100 lg:hidden"
            >
              <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
            </button>
          </div>
        </div>

        {open && (
          <div className="border-t border-background-200 bg-background-50 lg:hidden">
            <nav className="mx-auto flex max-w-[1280px] flex-col px-4 py-2 md:px-6">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="whitespace-nowrap border-b border-background-100 py-3 text-sm text-foreground-700 last:border-0"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}